module.exports = __webpack_public_path__ + "img/avartar.158f0e80.png";